import type { ProgramResult } from "./program-records";
import s from "../onepager.module.css";
const ordinal = new Intl.PluralRules("en", { type: "ordinal" });
const suffix: Readonly<Record<string, string>> = {
  one: "st",
  two: "nd",
  few: "rd",
};
function day(iso: string): string {
  return new Date(iso).toLocaleDateString("en", {
    month: "short",
    day: "numeric",
  });
}

export function ProgramResults({
  results,
}: {
  readonly results: readonly ProgramResult[] | null;
}) {
  if (results === null) return "sign in to see them";

  if (results.length === 0) return "none yet";

  return (
    <ul className={s.programGames}>
      {results.map((result) => (
        <li key={result.episodeId}>
          <span data-outcome={result.outcome ?? undefined}>
            {result.outcome ?? placeText(result.place)}
          </span>
          {result.opponents.length > 0
            ? ` vs ${result.opponents.slice(0, 2).join(", ")}${result.opponents.length > 2 ? ` +${result.opponents.length - 2}` : ""}`
            : ""}
          {` · ${day(result.at)}`}
          {result.replayHref ? (
            <>
              {" · "}
              <a href={result.replayHref}>replay</a>
            </>
          ) : null}
        </li>
      ))}
    </ul>
  );
}

function placeText(place: ProgramResult["place"]): string {
  if (!place) return "played";

  return `${place.rank}${suffix[ordinal.select(place.rank)] ?? "th"} of ${place.of}`;
}
